// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__h3zKL","truncatedText":"styles_truncatedText__LpRj5","fullText":"styles_fullText__Tgm8_","textContainer":"styles_textContainer__aY_Ob"};